//export const API_URL = 'http://localhost:3000';
export const API_URL = 'https://website-clement-dubois.oa.r.appspot.com'
// export const API_URL = 'https://apicldub.bengibert.com'